<av-content-container>
  <div class="col-12 d-flex align-items-stretch">
    <av-table-card
      [titleKey]="'app.device.applications.sections.software_inventory.title'"
      icon="apps"
      [columns]="softwareColumns"
      [rows]="softwareRows()"
      [countLabelKey]="'app.device.applications.count.software_inventory_found_suffix'"
      [emptyTextKey]="'app.device.applications.empty.software_inventory'"
      [pageSize]="10"
      [truncateAfter]="100" />
  </div>
</av-content-container>
